import React, { useState } from "react";
import { ErrorMessage, Formik } from "formik";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid2";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Snackbar from "@mui/material/Snackbar";
import { NavLink, useNavigate } from "react-router-dom";
import LockOpenRoundedIcon from "@mui/icons-material/LockOpenRounded";
import config from "../config/Config";
import InputAdornment from "@mui/material/InputAdornment";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import "../styles/authStyles/forgotPassword.css";

export default function ForgotPassword() {
  const [open, setOpen] = useState(true);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const navigate = useNavigate();
  const [detail, setDetail] = useState("");
  const [severityType, setSeverityType] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const vertical = "top";
  const horizontal = "center";

  const initialValues = {
    email: "",
  };

  const handleClose = () => {
    setOpen(false);
    navigate("/")
  };

  const handleClose1 = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  const onSubmit = (values) => {
    setIsLoading(true);
    fetch(`${config.baseUrl}email-forgot-password/`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: values.email }),
    }).then(async (response) => {
      const results = await response.json();
      if (response.status === 200) {
        setDetail(results.message);
        setSeverityType("success");
        setOpenSnackbar(true);
        await sleep(2000);
        setIsLoading(false);
        navigate("/");
      } else {
        setDetail(results.detail);
        setSeverityType("error");
        setOpenSnackbar(true);
        setIsLoading(false);
      }
    });
  };

  const validate = (values) => {
    let errors = {};

    if (!values.email && values.email.trim()) {
      errors.email = "Please enter correct email";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
    ) {
      errors.email = "Invalid email id address";
    }
    return errors;
  };

  const handleDialogClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      handleClose();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === " ") {
      e.preventDefault();
    }
  };

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  const handleEnd = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <Dialog
      onClose={handleDialogClose}
      aria-labelledby="customized-dialog-title"
      disableEscapeKeyDown={true}
      open={open}
      className="bgimage"
      hideBackdrop={false}
    >
      <div className="forgot-modal-dialog-title">
        <DialogTitle sx={{ m: 0, py: '3px',width:'100%'}} id="customized-dialog-title" >
          Forgot Password
        </DialogTitle>
        <CancelOutlinedIcon aria-label="close"
          onClick={handleClose}
          sx={{
            color: "white",
            fontSize: "28x",
            cursor:'pointer'
          }}
        />
      </div>
      <DialogContent dividers className="password-modal-body">
        <Formik
          initialValues={initialValues}
          validate={validate}
          onSubmit={onSubmit}
        >
          {({ values,handleChange,handleBlur,handleSubmit,isSubmitting,}) => (
            <form onSubmit={handleSubmit}>
              <Typography variant="h6" gutterBottom className="forgot-bold">
                <TextField
                  variant="standard"
                  margin="normal"
                  fullWidth
                  id="email"
                  name="email"
                  type="email"
                  className="email-text-field"
                  onKeyDown={handleKeyDown}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.email && values.email.trimStart()}
                  autoComplete="off"
                  placeholder="Email"
                  style={{ color: "black" }}
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <LockOpenRoundedIcon className="forgot-icons"/>
                        </InputAdornment>
                      ),
                    },
                  }}
                />
                <ErrorMessage name="email" component="div" className="error" />
                <Grid container spacing={2} className="form-layout-btn" >
                  <Button className="primary-btn"
                    type="submit"
                    variant="contained"
                    disabled={isLoading === true}
                  >
                    {isLoading === false ? "Submit" : (
                      <CircularProgress className="circular_spiner" size={24} sx={{color:"white"}} />
                    )}
                  </Button>
                  <NavLink style={{ textDecoration: "none", color: "#067DE2" }} exact to="/">
                    <Button
                      className="primary-btn-cancel"
                      variant="outlined"
                    >
                      Cancel
                    </Button>
                  </NavLink>
                </Grid>
              </Typography>
            </form>
          )}
        </Formik>
      </DialogContent>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleClose1}
        onEnded={handleEnd}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert onClose={handleClose1} severity={severityType} elevation={6} variant="filled">
          <div className="error" style={{ color: "white" }}>
            <span>{detail}</span>
          </div>
        </Alert>
      </Snackbar>
    </Dialog>
  );
}
